import React, { useState, useEffect } from "react";
import { Spinner, Tab, Tabs } from "react-bootstrap";
import { useSelector } from "react-redux";

//local components
import { toastMessage } from "../../shared/components/common/toast";
import BookCard from "../../shared/components/common/bookCard";

//styling
import "./style.css";
import {
  GetAllBooksforUser,
  GetAllBooksforVisitor,
  SearchBooksWithTitleforUser,
  SearchBooksWithAuthorforUser,
  SearchBooksWithTitleforVisitor,
  SearchBooksWithAuthorforVisitor,
} from "../../shared/services/libraryService";
import {
  ViewSwap,
  ViewSwapAll,
  SearchSwapBooksWithAuthorforUser,
  SearchSwapBooksWithAuthorforVisitor,
  SearchSwapBooksWithTitleforUser,
  SearchSwapBooksWithTitleforVisitor,
} from "../../shared/services/bookService";
import { NotFoundAnim } from "../../assets";
import Animation from "../../shared/components/common/Animation";

function MarketPlace() {
  const user = useSelector((state) => state.root.user);
  const [key, setKey] = useState("buy");
  const [booksList, setBooksList] = useState(null);
  const [loader, setLoader] = useState(false);
  const [searchType, setSearchType] = useState("title");
  const [search, setSearch] = useState("");
  useEffect(() => {
    if (user?.isLoggedIn) {
      setBooksList(null);
      setLoader(true);
      GetAllBooksforUser(user?.token)
        .then((res) => {
          if (res.statusText === "OK") {
            setBooksList(res.data);
            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log(error.message);
          setLoader(false);
        });
    } else {
      setLoader(true);
      setBooksList(null);
      GetAllBooksforVisitor()
        .then((res) => {
          if (res.statusText === "OK") {
            setBooksList(res.data);
            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log(error.message);
          setLoader(false);
        });
    }
  }, []);
  const handleOnBuy = () => {
    setBooksList(null);
    if (user?.isLoggedIn) {
      setLoader(true);
      GetAllBooksforUser(user?.token)
        .then((res) => {
          if (res.statusText === "OK") {
            setBooksList(res.data);
            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log(error.message);
          setLoader(false);
        });
    } else {
      setLoader(true);
      GetAllBooksforVisitor()
        .then((res) => {
          if (res.statusText === "OK") {
            setBooksList(res.data);
            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log(error.message);
          setLoader(false);
        });
    }
  };
  const handleOnSwap = async () => {
    setBooksList(null);
    if (user?.isLoggedIn) {
      setLoader(true);
      ViewSwap(user?.token)
        .then((res) => {
          if (res.statusText === "OK") {
            setBooksList(res.data);
            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log(error.message);
          setLoader(false);
        });
    } else {
      setLoader(true);
      ViewSwapAll()
        .then((res) => {
          if (res.statusText === "OK") {
            setBooksList(res.data);
            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log(error.message);
          setLoader(false);
        });
    }
  };
  const handleChange = (e) => {
    setBooksList([]);
    if (e.key === "Enter") {
      setLoader(true);
      let formData = {
        name: e.target.value,
      };
      if (user?.isLoggedIn) {
        searchType === "title"
          ? SearchBooksWithTitleforUser(user?.token, formData)
              .then((res) => {
                if (res.statusText === "OK") {
                  setBooksList(res.data);
                }
                setLoader(false);
              })
              .catch((error) => {
                console.log(error);
                setLoader(false);
              })
          : SearchBooksWithAuthorforUser(user?.token, formData)
              .then((res) => {
                if (res.statusText === "OK") {
                  setBooksList(res.data);
                }
                setLoader(false);
              })
              .catch((error) => {
                console.log(error);
                setLoader(false);
              });
      } else {
        searchType === "title"
          ? SearchBooksWithTitleforVisitor(formData)
              .then((res) => {
                if (res.statusText === "OK") {
                  setBooksList(res.data);
                }
                setLoader(false);
              })
              .catch((error) => {
                console.log(error);
                setLoader(false);
              })
          : SearchBooksWithAuthorforVisitor(formData)
              .then((res) => {
                if (res.statusText === "OK") {
                  setBooksList(res.data);
                }
                setLoader(false);
              })
              .catch((error) => {
                console.log(error);
                setLoader(false);
              });
      }
    }
  };
  const handleChangeforSwap = (e) => {
    setBooksList([]);
    if (e.key === "Enter") {
      setLoader(true);
      let formData = {
        name: e.target.value,
      };
      if (user?.isLoggedIn) {
        searchType === "title"
          ? SearchSwapBooksWithTitleforUser(user?.token, formData)
              .then((res) => {
                if (res.statusText === "OK") {
                  setBooksList(res.data);
                }
                setLoader(false);
              })
              .catch((error) => {
                console.log(error);
                setLoader(false);
              })
          : SearchSwapBooksWithAuthorforUser(user?.token, formData)
              .then((res) => {
                if (res.statusText === "OK") {
                  setBooksList(res.data);
                }
                setLoader(false);
              })
              .catch((error) => {
                console.log(error);
                setLoader(false);
              });
      } else {
        searchType === "title"
          ? SearchSwapBooksWithTitleforVisitor(formData)
              .then((res) => {
                if (res.statusText === "OK") {
                  setBooksList(res.data);
                }
                setLoader(false);
              })
              .catch((error) => {
                console.log(error);
                setLoader(false);
              })
          : SearchSwapBooksWithAuthorforVisitor(formData)
              .then((res) => {
                if (res.statusText === "OK") {
                  setBooksList(res.data);
                }
                setLoader(false);
              })
              .catch((error) => {
                console.log(error);
                setLoader(false);
              });
      }
    }
  };
  return (
    <div>
      <div className="container" data-aos="fade-up" data-aos-duration="500">
        <h2 className="driptivity-text">Market Place</h2>
        <div className="driptivity-content">
          <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
            <Tab
              eventKey="buy"
              title="BUY"
              onEnter={handleOnBuy}
              disabled={loader}
            >
              <section className="driptivity-content-tour">
                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex row justify-content-center m-auto">
                      <div className="text-center search_searchinput col-10 p-0">
                        <input
                          type="text"
                          className="w-100 mb-4 ps-3 pt-2 pb-2 pe-5 rounded search_inputag"
                          placeholder="Search..."
                          onKeyPress={(e) => handleChange(e)}
                        ></input>
                        <span className="search_iconinside">
                          <img
                            src={
                              require("../../assets/icons/search.svg").default
                            }
                            width="20"
                            height="20"
                            alt="search-icon"
                          />
                        </span>
                      </div>
                      <div className="col-2 p-0 pl-2">
                        <select
                          name="type"
                          id="type"
                          className="select-tag search_inputag "
                          onChange={(e) => setSearchType(e.target.value)}
                        >
                          <option value="title">Title</option>
                          <option value="author">Author</option>
                        </select>
                      </div>
                    </div>
                    <div className={`recent-activity-flex`}>
                      {loader ? (
                        <div className="d-flex align-items-center">
                          <Spinner animation="grow" size="lg" />
                        </div>
                      ) : booksList && booksList.length > 0 ? (
                        booksList?.map((item, index) => {
                          return (
                            <BookCard
                              isBuy
                              item={item}
                              key={index}
                              handleOnBuy={handleOnBuy}
                            />
                          );
                        })
                      ) : (
                        <div className="animation-container">
                          <Animation
                            Pic={NotFoundAnim}
                            Message={"No Books Found"}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </Tab>
            <Tab
              eventKey="swap"
              title="SWAP"
              onEnter={handleOnSwap}
              disabled={loader}
            >
              <section className="driptivity-content-tour">
                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex row justify-content-center m-auto">
                      <div className="text-center search_searchinput col-10 p-0">
                        <input
                          type="text"
                          className="w-100 mb-4 ps-3 pt-2 pb-2 pe-5 rounded search_inputag"
                          placeholder="Search..."
                          onKeyPress={(e) => handleChangeforSwap(e)}
                        ></input>
                        <span className="search_iconinside">
                          <img
                            src={
                              require("../../assets/icons/search.svg").default
                            }
                            width="20"
                            height="20"
                            alt="search-icon"
                          />
                        </span>
                      </div>
                      <div className="col-2 p-0 pl-2">
                        <select
                          name="type"
                          id="type"
                          className="select-tag search_inputag "
                          onChange={(e) => setSearchType(e.target.value)}
                        >
                          <option value="title">Title</option>
                          <option value="author">Author</option>
                        </select>
                      </div>
                    </div>
                    <div className={`recent-activity-flex`}>
                      {loader ? (
                        <div className="d-flex align-items-center">
                          <Spinner animation="grow" size="lg" />
                        </div>
                      ) : booksList && booksList.length > 0 ? (
                        booksList?.map((item, index) => {
                          return (
                            <BookCard
                              isSwap
                              item={item.library}
                              key={index}
                              bookID={item._id}
                              token={item.token}
                              offerred={item.offer}
                              handleOnSwap={handleOnSwap}
                            />
                          );
                        })
                      ) : (
                        <div className="animation-container">
                          <Animation
                            Pic={NotFoundAnim}
                            Message={"No Books Found"}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
}

export default MarketPlace;
